import type { NotifyOptionsSuccess, NotifyOptionsError, NotifierConfig } from "@modernary/mui/components/notifications";
import type { ChangeNotification } from "@/views/changeNotification/changeNotification";
import { apiService } from "@modernary/mui/utils/api";
import { apiHosts } from "@/api/constants/apiHosts";

const URL = "change-notifications";
const ENTITY_NAME = "Request";

const axiosParams = {
  // Set different base URL based on the environment
  baseURL: import.meta.env.VITE_ODR_API_BASE_URL,
};
const api = apiService<ChangeNotification>(apiHosts.ODR, axiosParams);

const createChangeNotification = (changeNotification: ChangeNotification, config: NotifierConfig = {}) => {
  const successNotifCb = (options: NotifyOptionsSuccess) => {
    options.title = "Change Notification Submitted";
    config?.successNotifCb?.(options);
  };
  const errorNotifCb = (options: NotifyOptionsError) => {
    options.created = ENTITY_NAME;
    config?.errorNotifCb?.(options);
  };

  return api.post(URL, changeNotification, {
    successNotifCb,
    errorNotifCb,
  });
};

export { createChangeNotification };
